/* Public totals are separate from the customer's private Favorites list. */
(function () {
  'use strict';
  var ENDPOINT = '/apps/credits/favorites-discovery';
  var totals = {}, pending = {}, revisions = {}, timer, observer, active = 0;
  function format(n) { return n < 1000 ? String(n) : n < 1000000 ? Math.floor(n / 1000) + 'k' : Math.floor(n / 1000000) + 'm'; }
  function draw(id) {
    document.querySelectorAll('kc-favorite[data-product-id="' + id + '"] [data-kc-like-total]').forEach(function (el) {
      var n = totals[id];
      el.textContent = typeof n === 'number' && n > 0 ? format(n) : '';
      el.style.visibility = n > 0 ? 'visible' : 'hidden';
      el.title = n > 0 ? n.toLocaleString('en-US') + ' likes' : '';
      var btn = el.closest('.kc-fav__btn');
      if (btn) {
        if (!btn.dataset.kcBaseLabel) btn.dataset.kcBaseLabel = btn.getAttribute('aria-label') || 'Like this design';
        btn.setAttribute('aria-label', btn.dataset.kcBaseLabel + (n > 0 ? ', ' + n.toLocaleString('en-US') + ' likes' : ''));
      }
    });
  }
  function read(url) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, 10000) : null;
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error('Like discovery unavailable'); return res.json(); })
      .then(function (body) { if (!body || body.ok !== true) throw new Error('Like discovery unavailable'); return body; })
      .finally(function () { if (timeout) clearTimeout(timeout); });
  }
  function flush() {
    timer = null;
    if (active >= 2) { timer = setTimeout(flush, 100); return; }
    var ids = Object.keys(pending).slice(0, 100);
    var versions = {};
    ids.forEach(function (id) { versions[id] = revisions[id] || 0; });
    if (!ids.length) return;
    ids.forEach(function (id) { delete pending[id]; });
    active++;
    read(ENDPOINT + '?mode=counts&ids=' + ids.join(',')).then(function (body) {
      ids.forEach(function (id) {
        if (versions[id] !== (revisions[id] || 0)) return;
        var n = body.counts && body.counts[id];
        if (Number.isSafeInteger(n) && n >= 0) totals[id] = n;
        else delete totals[id];
        draw(id);
      });
    }).catch(function () { /* Unknown totals stay blank, never invented. */ }).finally(function () {
      active--; if (Object.keys(pending).length && !timer) timer = setTimeout(flush, 50);
    });
  }
  function queue(id, force) {
    if (!/^[1-9][0-9]{0,18}$/.test(id)) return;
    if (force || totals[id] === undefined) {
      revisions[id] = (revisions[id] || 0) + 1;
      pending[id] = true;
    }
    draw(id);
    if (!timer && Object.keys(pending).length) timer = setTimeout(flush, 50);
  }
  function savedUrl() {
    var url = new URL('/pages/favorites', location.origin);
    var collection = location.pathname.match(/^\/collections\/([^/]+)/);
    if (collection && collection[1] !== 'all') url.searchParams.set('collection', decodeURIComponent(collection[1]));
    new URLSearchParams(location.search).forEach(function (value, key) {
      if (key.indexOf('filter.p.') === 0 || key.indexOf('filter.v.') === 0) url.searchParams.append(key, value);
      if (key === 'q') url.searchParams.set('query', value);
    });
    return url.pathname + url.search;
  }
  function scan() {
    document.querySelectorAll('kc-favorite[data-product-id]').forEach(function (el) {
      if (el.dataset.kcCountObserved) return;
      el.dataset.kcCountObserved = 'true';
      if (observer) observer.observe(el); else queue(el.getAttribute('data-product-id'));
    });
    document.querySelectorAll('[data-kc-liked-link]').forEach(function (a) { a.href = savedUrl(); });
  }
  function startPopular(el) {
    var grid = el.querySelector('[data-kc-popular-grid]'), status = el.querySelector('[data-kc-popular-status]');
    var more = el.querySelector('[data-kc-popular-more]'), cursor = '0', busy = false, seen = {}, shown = 0;
    function load() {
      if (busy || cursor === null) return;
      busy = true; more.disabled = true; status.textContent = 'Loading most liked files.';
      var next, items;
      read(ENDPOINT + '?mode=popular&cursor=' + cursor).then(function (body) {
        items = body.items; next = body.next;
        if (!Array.isArray(items) || !(next === null || /^[0-9]+$/.test(next))) throw new Error('Invalid ranking');
        var ids = items.map(function (item) {
          if (!/^[1-9][0-9]{0,18}$/.test(item.id) || !Number.isSafeInteger(item.count) || item.count < 1) throw new Error('Invalid ranking');
          totals[item.id] = item.count; return item.id;
        });
        if (!ids.length) return '';
        var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
        return fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=kc-favorites-results', { credentials: 'same-origin' })
          .then(function (res) { if (!res.ok) throw new Error('Could not load cards'); return res.text(); });
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var found = {};
        doc.querySelectorAll('[data-kc-fav-item]').forEach(function (item) { found[item.getAttribute('data-kc-fav-item')] = item; });
        items.forEach(function (item) {
          var node = found[item.id];
          if (!seen[item.id] && node && node.querySelector('.product-card')) {
            grid.appendChild(document.importNode(node, true)); seen[item.id] = true; shown++; draw(item.id);
          }
        });
        cursor = next;
        more.hidden = cursor === null;
        status.textContent = shown ? shown + ' liked designs shown. Ranked across all files.' : cursor === null ? 'No liked files to show yet.' : 'No matching files in this batch.';
        if (!shown && cursor !== null) setTimeout(load, 0);
      }).catch(function () {
        status.textContent = 'We could not load most liked files. Try again.';
        more.textContent = 'Try again'; more.hidden = false;
      }).finally(function () { busy = false; more.disabled = false; });
    }
    more.addEventListener('click', load);
    load();
  }
  if ('IntersectionObserver' in window) observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { observer.unobserve(entry.target); queue(entry.target.getAttribute('data-product-id')); }
    });
  }, { rootMargin: '250px' });
  function ready() {
    scan();
    var mutations = new MutationObserver(scan);
    mutations.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', function (event) {
      if (event.persisted) return;
      mutations.disconnect();
      if (observer) observer.disconnect();
      if (timer) clearTimeout(timer);
    });
    document.querySelectorAll('[data-kc-popular]').forEach(startPopular);
  }
  document.addEventListener('kc:favorite-saved', function (event) { queue(String(event.detail.productId), true); });
  document.addEventListener('change', function (event) {
    if (event.target.matches('select[name="sort_by"]') && event.target.value === 'kc-most-liked') {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign('/pages/most-liked');
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
